export const FOOTER_INFO = {
  brand: 'CodingFlash',
  description:
    'Diseñamos y desarrollamos productos digitales para equipos que necesitan vender más y operar mejor.',
  legal: [
    {
      id: 'privacy',
      label: 'Política de privacidad',
      href: '/privacidad',
    },
    {
      id: 'terms',
      label: 'Términos y condiciones',
      href: '/terminos',
    },
  ],
  social: [
    {
      id: 'linkedin',
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/codingflash/posts/?feedView=all',
    },
    {
      id: 'instagram',
      label: 'Instagram',
      href: 'https://www.instagram.com/coding.flash?igsh=NXUxbHp5cmR6Nm5w&utm_source=qr',
    },
  ],
  location: 'Argentina / Colombia / El resto del mundo',
  email: 'codingflash.agency@gmail.com',
  copyright: '© 2026 CODINGFLASH STUDIO',
};
